import React from 'react';
import { FunctionField, useRecordContext } from 'react-admin';
import { RateSettingsDisplayHelper } from 'utils/displayHelpers/rate-settings';

const UsingBlendedRateField = ({ forceNestedObject, showInheritanceLabel, source, variant }) => {
  const record = useRecordContext();
  const settings = source ? record?.[source] : record?.settings;

  return (
    <FunctionField
      render={({ location }) => {
        const rateSettingsDisplayHelper = new RateSettingsDisplayHelper({
          location,
          settings,
        });

        const activeRate = rateSettingsDisplayHelper.getActiveRate(forceNestedObject);

        switch (activeRate) {
          case 'blended-rate':
            return variant === 'rate-structure' ? '12h' : 'Yes';
          case '8-hour-rate':
            return variant === 'rate-structure' ? '8h' : 'No';
          default:
            return showInheritanceLabel ? 'Applied inheritance' : '';
        }
      }}
    />
  );
};

UsingBlendedRateField.defaultProps = {
  label: 'Using 12h location rate structure',
  forceNestedObject: null,
  showInheritanceLabel: false,
  source: null,
  variant: 'boolean',
};

export default UsingBlendedRateField;
